import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import Constants from '../constants.ts';
import { action } from '@ember/object';

export interface AditoolsFooterSignature {
  Element: HTMLElement;
  Args: {
    siteURL?: string;
    locale?: string;
  };
}
type AditoolsFooterArgs = AditoolsFooterSignature['Args'];

export default class AditoolsFooter extends Component<AditoolsFooterSignature> {
  constructor(owner: unknown, args: AditoolsFooterArgs) {
    super(owner, args);
    assert('ADI domains now use https -- check `siteURL` string', this._siteURL.startsWith('https'));
    assert(
      'Locale should be one of the following: en/jp/cn/ru',
      this._locale === 'en' || this._locale === 'jp' || this._locale === 'cn' || this._locale === 'ru'
    );
  }

  // Optional parameters with defaults applied
  get _siteURL() {
    return this.args.siteURL ?? 'https://www.analog.com';
  }

  get _locale() {
    return this.args.locale ?? 'en';
  }

  get sitemapURL() {
    return Constants.urls.sitemap.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get legalURL() {
    return Constants.urls.legal.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get accessibilityURL() {
    return Constants.urls.accessibility.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get privacyPolicyURL() {
    return Constants.urls.privacyPolicy.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get privacySettingsURL() {
    return Constants.urls.privacySettings.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get cookieSettingsURL() {
    return Constants.urls.cookieSettings.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  @action doNotAddToUrl(e: Event): void {
    e.preventDefault(); // Cancel the native event
  }
}
